import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Form, FormInput } from 'shared/components'

import * as style from './styles'

import { getOptionLabel, getOptionValue } from './helpers'

// Simple options for marketing promotion filter
const marketingOptions = [
  { id: '', name: 'All' },
  { id: 'true', name: 'Yes' },
  { id: 'false', name: 'No' },
]

const TournamentsFiltersComponent = ({ form, loadSportTypes }) => (
  <Form form={form}>
    <Grid>
      <Row css={style.filtersWrapper}>
        <Col xs={12} sm={4}>
          <FormInput
            name="search"
            icon="search"
            placeholder="Search by name..."
            css={style.phoneSpace}
            grayBg
          />
        </Col>
        <Col xs={12} sm={4}>
          <FormInput
            fluid
            defaultOptions
            isClearable
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="sportTypes"
            placeholder="Sport"
            loadOptions={loadSportTypes}
            oldInput
            iconOptioned
          />
        </Col>

        <Col xs={12} sm={4}>
          <FormInput
            fluid
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="select"
            name="marketingPromotionSelect"
            placeholder="Marketing Promotion"
            css={style.phoneSpace}
            options={marketingOptions}
            oldInput
          />
        </Col>
      </Row>
    </Grid>
  </Form>
)

TournamentsFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  loadSportTypes: PropTypes.func.isRequired,
}

export default TournamentsFiltersComponent
